import ClientUtils from './utils';

export default {
    postBatchPrintRequest: (payload, callback, failureCallback) => {
        const url = '/student-profile/batch-print';

        return ClientUtils.makePostRequest(url, callback, payload, null, failureCallback, null, true);
    },
};
